import(/* webpackMode: "eager", webpackExports: ["TeamLeaguesClientWrapper"] */ "/app/apps/pickleball/src/modules/players/v2/tabs/team-leagues/TeamLeaguesClientWrapper.tsx");
